export const CLEAR_AUTH_DATA = 'clear_auth_data';
export const SET_KEYCLOAK_INSTANCE = 'set_keycloak_instance';
export const LOAD_AUTH_DATA = 'load_auth_data';
export const SET_AUTH_TOKEN = 'set_auth_token';
export const SET_REMAINING_TIME = 'set_remaining_time';
export const SET_RECENT_API_CALLS = 'set_recent_api_calls';
export const SET_REFRESH = 'set_refresh';
export const SET_LOADING ='set_loading'